const heading = {
  display: `block`,
  color: `heading`,
  fontWeight: `heading`,
  textDecoration: `none`,
  mb: 3
}

const text = {
  heading: {
    ...heading
  },
  hero: {
    ...heading,
    fontSize: [5, 6, null, 8],
    fontWeight: `bold`
  },
  h1: {
    ...heading,
    fontSize: [5, 6, null, 7],
    fontWeight: `bold`
  },
  h2: {
    ...heading,
    fontSize: 4
  },
  h3: {
    ...heading,
    fontSize: 3
  },
  h4: {
    ...heading,
    fontSize: 2,
    fontWeight: `bold`
  },
  h5: {
    ...heading,
    fontSize: 1,
    fontWeight: `bold`
  },
  headline: {
    fontSize: 3,
    fontWeight: `body`
  },
  medium: {
    fontSize: 3,
    mb: 3
  },
  small: {
    fontSize: 1,
    m: 0
  },
  xsmall: {
    fontSize: 0,
    m: 0
  },
  navlink: {
    fontSize: 2,
    color: `article` 
  },
  p: {
    fontFamily: `body`,
    mb: 3
  }
}

export default text